import fetch from 'auth/FetchInterceptor'
import eventoService from './EventoService'

const templateService = {}

// ==================== TEMPLATES DE EMAIL ====================

templateService.getTemplatesEmail = function () {
  return fetch({
    url: '/templates/email',
    method: 'get',
    headers: {
      'apelidoEvento': eventoService.getApelidoEvento()
    }
  })
}

templateService.getTemplateEmailAtivo = function () {
  return fetch({
    url: '/templates/email/ativo',
    method: 'get',
    headers: {
      'apelidoEvento': eventoService.getApelidoEvento()
    }
  })
}

templateService.getTemplateEmail = function (id) {
  return fetch({
    url: `/templates/email/${id}`,
    method: 'get'
  })
}

templateService.criarTemplateEmail = function (template) {
  return fetch({
    url: '/templates/email',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'apelidoEvento': eventoService.getApelidoEvento()
    },
    data: template
  })
}

templateService.atualizarTemplateEmail = function (id, template) {
  return fetch({
    url: `/templates/email/${id}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: template
  })
}

templateService.excluirTemplateEmail = function (id) {
  return fetch({
    url: `/templates/email/${id}`,
    method: 'delete'
  })
}

templateService.previewTemplateEmail = function (id, variaveis = {}) {
  return fetch({
    url: `/templates/email/${id}/preview`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: variaveis,
    responseType: 'text'
  })
}

templateService.duplicarTemplateEmail = function (id, novoNome = null) {
  return fetch({
    url: `/templates/email/${id}/duplicar`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'apelidoEvento': eventoService.getApelidoEvento()
    },
    data: { novoNome }
  })
}

// ==================== TEMPLATES DE PDF ====================

templateService.getTemplatesPdf = function () {
  return fetch({
    url: '/templates/pdf',
    method: 'get',
    headers: {
      'apelidoEvento': eventoService.getApelidoEvento()
    }
  })
}

templateService.getTemplatePdfAtivo = function () {
  return fetch({
    url: '/templates/pdf/ativo',
    method: 'get',
    headers: {
      'apelidoEvento': eventoService.getApelidoEvento()
    }
  })
}

templateService.getTemplatePdf = function (id) {
  return fetch({
    url: `/templates/pdf/${id}`,
    method: 'get'
  })
}

templateService.criarTemplatePdf = function (template) {
  return fetch({
    url: '/templates/pdf',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'apelidoEvento': eventoService.getApelidoEvento()
    },
    data: template
  })
}

templateService.atualizarTemplatePdf = function (id, template) {
  return fetch({
    url: `/templates/pdf/${id}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: template
  })
}

templateService.excluirTemplatePdf = function (id) {
  return fetch({
    url: `/templates/pdf/${id}`,
    method: 'delete'
  })
}

templateService.previewTemplatePdf = function (id, variaveis = {}) {
  return fetch({
    url: `/templates/pdf/${id}/preview`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: variaveis,
    responseType: 'blob'
  })
}

templateService.duplicarTemplatePdf = function (id, novoNome = null) {
  return fetch({
    url: `/templates/pdf/${id}/duplicar`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'apelidoEvento': eventoService.getApelidoEvento()
    },
    data: { novoNome }
  })
}

// ==================== VARIAVEIS ====================

templateService.getVariaveis = function (contexto = null) {
  let url = '/templates/variaveis'
  if (contexto) {
    url += `?contexto=${contexto}`
  }
  return fetch({
    url: url,
    method: 'get'
  })
}

export default templateService
